import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { withPromisedComponent } from "@components/dialog/withPromisedComponent";
import { DocumentTypeCode } from "@odata/GeneratedEnums";
import { checkEmployeeTypeAndSetVariant, isEmployeeBPType } from "@pages/documents/otherLiability/OtherLiability.utils";

import { withDomManipulator } from "../../../contexts/domManipulator/withDomManipulator";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { IProps } from "../../../views/formView/Form";
import { withAccruals } from "../extensions/accruals/withAccruals";
import { withTimeResolution } from "../extensions/timeResolution/withTimeResolution";
import IssuedDocumentBaseFormView from "../IssuedDocumentBaseFormView";


class OtherReceivableFormView extends IssuedDocumentBaseFormView {
    documentTypeCode = DocumentTypeCode.OtherReceivable;
    documentTypePropName = "ReceivableType";

    preloadCheck = () => checkEmployeeTypeAndSetVariant(this.props.storage);

    getFormProps = (): Partial<IProps> => {
        const { storage, formProps = {} } = this.props;
        const isEmployee = isEmployeeBPType(storage.data.entity.BusinessPartner);
        return {
            shouldHideVariant: isEmployee ? true : formProps.shouldHideVariant,
            ...formProps
        };
    };
}

export default withPromisedComponent(withConfirmationDialog(withTimeResolution(withAccruals({ isExpense: false })(withPermissionContext(withDomManipulator(OtherReceivableFormView))))));
